<script setup lang="ts">
import { watch } from 'vue'
import { useRouter } from 'vue-router'
import AppRail from '../components/AppRail.vue'
import ChatView from '../components/chat/ChatView.vue'
import ConversationList from '../components/list/ConversationList.vue'
import SidePanel from '../components/side/SidePanel.vue'
import MenuReadModal from '../components/chat/MenuReadModal.vue'
import { useInbox } from '../stores/inbox'
import { useMenuRead } from '../stores/menuRead'

const props = defineProps<{ id?: string }>()
const store = useInbox()

watch(
  () => props.id,
  (id) => void store.select(id ?? null),
  { immediate: true },
)
// อ่านเมนูจากแชท: the recheck modal lives here once; the expanded menu grid (ลงออเดอร์ › ขยาย) takes the chat list's
// room and closes when another chat opens
const mr = useMenuRead()
watch(
  () => store.selectedId,
  (sid) => {
    if (mr.wideConv && mr.wideConv !== sid) mr.collapse()
    if (mr.src && mr.src.convId !== sid) mr.close()
  },
)
// the open chat was deleted ("ล้างแชทนี้ (ทดสอบ)", here or on another screen): leave /c/:id for the empty inbox
const router = useRouter()
watch(
  () => store.selectedId,
  (sid) => {
    if (!sid && props.id) void router.replace({ name: 'inbox' })
  },
)
</script>

<template>
  <div class="app">
    <AppRail />
    <ConversationList v-show="!(mr.wideConv && mr.wideConv === store.selectedId)" />
    <ChatView />
    <SidePanel />
    <div v-if="store.realtimeStatus === 'reconnecting'" class="net" role="status">
      กำลังต่อการแจ้งเตือนสดใหม่ ข้อความใหม่อาจขึ้นช้า
    </div>
    <div v-if="store.toast" class="toast" role="status">{{ store.toast }}</div>
    <MenuReadModal />
  </div>
</template>

<style scoped>
.app {
  position: relative;
  display: flex;
  height: 100vh;
  min-height: 640px;
  overflow: hidden;
  background: var(--bg);
}
.toast,
.net {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 20px;
  box-shadow: 0 8px 24px rgba(23, 33, 28, 0.18);
}
.toast {
  bottom: 24px;
  background: #17211c;
  color: #fff;
}
.net {
  top: 12px;
  background: var(--warns);
  color: #6b4300;
  border: 1px solid #f0dca6;
}
</style>
